﻿import { Component, OnInit } from '@angular/core';
import { DataService } from '../../shared/dataservice.service';

@Component({
  selector: 'app-inpr-qual-issu',
  templateUrl: './inpr-qual-issu.component.html',
  styleUrls: ['./inpr-qual-issu.component.css']
})
export class InprQualIssuComponent implements OnInit {

  
  selView:number = 0;
  mId:string = "773881e1-3f3a-49be-865a-1a2f0312be8d";
  hasmodaccess: boolean = false;
  

  constructor(public _dataService: DataService) { }

  ngOnInit() {
    this._dataService.currPageName = "Inprocess Quality Issues";
        
  }

  checkModAccess(): boolean {
    if (this._dataService.mAccess(this.mId) == true) {
      this.hasmodaccess = true;
    }
    else {
      this.hasmodaccess = false;
    }
    return this.hasmodaccess;
  }
  
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }
}
